import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const FestivalServicesPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('festival');

  return (
    <ServicePageTemplate
      serviceType="festival"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default FestivalServicesPage;

